/**
 * Lo que comparten la lista de ClinicPilot Drive y su visor (14/10/2026):
 * el tamaño legible y el icono de cada tipo de archivo.
 */
import React from 'react';
import { FileText, FileSpreadsheet, Image as ImageIcon, File as FileIcon } from 'lucide-react';

/** "1.2 MB" a partir de bytes. */
export function tamano(bytes) {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function tipoDoc(doc) {
  const mime = doc.mime || '';
  const nombre = (doc.name || '').toLowerCase();
  if (mime === 'application/pdf' || nombre.endsWith('.pdf')) {
    return { Icono: FileText, color: 'text-red-600', fondo: 'bg-red-50 dark:bg-red-950/30' };
  }
  if (mime.startsWith('image/')) {
    return { Icono: ImageIcon, color: 'text-purple-600', fondo: 'bg-purple-50 dark:bg-purple-950/30' };
  }
  if (/\.(xlsx?|csv)$/.test(nombre) || mime.includes('spreadsheet') || mime.includes('excel')) {
    return { Icono: FileSpreadsheet, color: 'text-emerald-600', fondo: 'bg-emerald-50 dark:bg-emerald-950/30' };
  }
  if (/\.(docx?)$/.test(nombre) || mime.includes('word')) {
    return { Icono: FileText, color: 'text-sky-600', fondo: 'bg-sky-50 dark:bg-sky-950/30' };
  }
  return { Icono: FileIcon, color: 'text-muted-foreground', fondo: 'bg-muted' };
}

/**
 * Icono dentro de un cuadrado teñido de su color (2026-07-27). Antes el glifo
 * iba suelto sobre el fondo y la lista se leía como un listado de texto.
 */
export function FichaTipo({ doc, size = 36 }) {
  const { Icono, color, fondo } = tipoDoc(doc);
  return (
    <span style={{ width: size, height: size }}
      className={`shrink-0 rounded-[10px] inline-flex items-center justify-center ${fondo}`}>
      <Icono className={`w-[55%] h-[55%] ${color}`} />
    </span>
  );
}
